import dayjs from 'dayjs'
import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { BaseContent, Dropdown, Icon, Tag, ToolbarButton } from '@fourthwall/components'
import { DesktopIcon, DotsHorizontalIcon, MobileIcon } from '@fourthwall/icons'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { Device } from '../../Security.types'
import * as S from './DeviceList.styled'

export type DeviceListProps = {
  items: (Device & {
    onDelete?: () => void
  })[]
}

export const DeviceList = ({ items }: DeviceListProps) => {
  const deviceTypeIconMap: Record<Device['type'], IconComponent> = {
    MOBILE: MobileIcon,
    DESKTOP: DesktopIcon,
  }

  const formatLastActiveTime = (lastActive: string) => {
    const date = dayjs(new Date(lastActive))
    if (date.isSame(dayjs(), 'day')) {
      return <TimezonedDateString date={lastActive} format="[today at] HH:mm A" />
    }

    return <TimezonedDateString date={lastActive} format="MMM D [at] HH:mm A" />
  }

  return (
    <S.Container>
      {items.map((item) => (
        <S.Item key={item.id}>
          <div>
            <Icon component={deviceTypeIconMap[item.type]} height={20} />
          </div>
          <S.ItemTextContent>
            <BaseContent>
              {item.name}{' '}
              {item.isActive && (
                <S.ItemStatus>
                  <Tag label="this device" appearance="success" />
                </S.ItemStatus>
              )}
            </BaseContent>
            <BaseContent appearance="secondary" size="small">
              {item.lastActive && <div>Last active {formatLastActiveTime(item.lastActive)}</div>}
              <div>IP: {item.address}</div>
            </BaseContent>
          </S.ItemTextContent>
          {item.onDelete && (
            <div>
              <Dropdown content={<Dropdown.Item label="Delete" onClick={item.onDelete} />}>
                <ToolbarButton icon={DotsHorizontalIcon} size="small" />
              </Dropdown>
            </div>
          )}
        </S.Item>
      ))}
    </S.Container>
  )
}
